import { render } from "./SaveEmployee.vue?vue&type=template&id=93a59efa&scoped=true"
import script from "./SaveEmployee.vue?vue&type=script&lang=js"
export * from "./SaveEmployee.vue?vue&type=script&lang=js"

import "./employee.scss?vue&type=style&index=0&id=93a59efa&lang=scss&scoped=true"
import "./SaveEmployee.vue?vue&type=style&index=1&id=93a59efa&lang=css"

import exportComponent from "/Users/tathonglam/docker/src/client/weconcept/star168.hk/star168_backend.git/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93a59efa"]])

export default __exports__